import React from 'react';
import './careerStartSection.scss';

const CareerStartSection = () => {
	const handlePress = () => {
		const block = document.querySelector(`.supportIdeas`) as HTMLDivElement;
		if (block) {
			block.scrollIntoView({ behavior: 'smooth' });
		}
	}

	return (
		<div className="careerStart">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="careerStart__background_first"></div>
			<div className="careerStart__background_second"></div>
			<div className="careerStart__content">
				<div className="careerStart__content_title">
					<h1>Help us make Web-3 great</h1>
					<span>We look forward to having you on our team.</span>
				</div>
				<div className="careerStart__content_button">
					<button
						className="secondButton"
						onClick={handlePress}
					>
						<span>Talk about yourself</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default CareerStartSection;